import { html } from '../AppElement';
import Constants from '../Constants';
import NumericVarianceBlock from '../numericVarianceBlock/NumericVarianceBlock';
import PickupPerMonth from './PickupPerMonth';

export default class PickupPerMonthHotel extends PickupPerMonth {
    static get properties() {
        return {
            recordDate: { type: String },
            hotel: { type: Object },
            pickupSetting: { type: String }
        };
    }

    constructor(props = {}) {
        super(props);
        this.isgroup = infinito.vao.controller.storageHelper.getState();
        this.hotel = props.hotel;
    }

    reflow(props = {}) {
        super.reflow(props);
        this.hotel = props.hotel || this.hotel;
    }

    getTableStateKey() {
        return 'hotel';
    }

    fillRows() {
        infinito.vao.model.flashApi.fetchHotelFlashMonthlyPickup(
            this.hotel.id,
            this.recordDate,
            this.pickupSetting,
            (data) => {
                if (!data || !data.values || data.values.length === 0) {
                    super.empty();
                    return;
                }

                let foundAnyData = false;

                // Process each month in the response
                data.values.forEach((monthData) => {
                    const monthLabel = monthData.monthLabel;
                    const row = this.cache.rowMap.get(monthLabel);

                    if (!row) return; // Skip if row doesn't exist

                    let cell;

                    // Occupancy
                    cell = row.tableCellPerField.get(this.cellFieldMap.occ);
                    if ($.isNumeric(monthData.occupancy.value)) {
                        foundAnyData = true;
                        cell.value = this.formatPercentageValue(monthData.occupancy.value);
                    } else {
                        cell.value = null;
                    }
                    cell.isLoading = false;

                    // Rooms
                    cell = row.tableCellPerField.get(this.cellFieldMap.rms);
                    if ($.isNumeric(monthData.rooms.value)) {
                        foundAnyData = true;
                        cell.value = html`
                            <div style="flex-direction:column;">
                                <div>${monthData.rooms.value}</div>
                            </div>`;
                    } else {
                        cell.value = null;
                    }
                    cell.isLoading = false;

                    // ADR
                    cell = row.tableCellPerField.get(this.cellFieldMap.adr);
                    if ($.isNumeric(monthData.adr.value)) {
                        foundAnyData = true;
                        const formatted = window.infinito.vao.controller.moneyHelper.formatMoneyBracketStyle(
                            monthData.adr.value,
                            Constants.ADR_DIGITS,
                            true,
                            this.hotel.locale
                        );
                        cell.value = html`
                            <div style="flex-direction:column;">
                                <div>${formatted}</div>
                            </div>`;
                    } else {
                        cell.value = null;
                    }
                    cell.isLoading = false;

                    // Revenue
                    cell = row.tableCellPerField.get(this.cellFieldMap.rev);
                    if ($.isNumeric(monthData.revenue.value)) {
                        foundAnyData = true;
                        const formatted = window.infinito.vao.controller.moneyHelper.formatMoneyBracketStyle(
                            monthData.revenue.value,
                            Constants.REVENUE_DIGITS,
                            true,
                            this.hotel.locale
                        );
                        cell.value = html`
                            <div style="flex-direction:column;">
                                <div>${formatted}</div>
                            </div>`;
                    } else {
                        cell.value = null;
                    }
                    cell.isLoading = false;

                    // Pickup Rooms
                    cell = row.tableCellPerField.get(this.cellFieldMap.pkuprms);
                    if ($.isNumeric(monthData.rooms.diff)) {
                        foundAnyData = true;
                        const numVarBlock = new NumericVarianceBlock({
                            numericValue: monthData.rooms.diff,
                            formattedValue: String(monthData.rooms.diff),
                            beEmptyOnEmpty: 'true'
                        });

                        const varBlock = numVarBlock.isEmpty()
                            ? html``
                            : html`
                                    <div style="font-size:.7rem">${numVarBlock}</div>`;

                        cell.value = html`
                            <div style="flex-direction:column;">
                                <div>${varBlock}</div>
                            </div>`;
                    } else {
                        cell.value = null;
                    }
                    cell.isLoading = false;

                    // Pickup ADR
                    cell = row.tableCellPerField.get(this.cellFieldMap.pkupadr);
                    if ($.isNumeric(monthData.adr.diff)) {
                        foundAnyData = true;
                        let varBlock;
                        if (monthData.adr.diff > 0 || monthData.adr.diff < 0) {
                            const formatted = window.infinito.vao.controller.moneyHelper.formatMoneyBracketStyle(
                                monthData.adr.diff,
                                Constants.ADR_DIGITS,
                                true,
                                this.hotel.locale
                            );
                            const _varBlock = new NumericVarianceBlock({
                                numericValue: monthData.adr.diff,
                                formattedValue: formatted,
                                beEmptyOnEmpty: 'true'
                            });
                            varBlock = html`
                                <div style="font-size:.7rem;">${_varBlock}</div>`;
                        } else {
                            varBlock = html``;
                        }
                        cell.value = html`
                            <div style="flex-direction:column;">
                                <div>${varBlock}</div>
                            </div>`;
                    } else {
                        cell.value = null;
                    }
                    cell.isLoading = false;

                    // Pickup Revenue
                    cell = row.tableCellPerField.get(this.cellFieldMap.pkuprev);
                    if ($.isNumeric(monthData.revenue.diff)) {
                        foundAnyData = true;
                        let varBlock;
                        if (monthData.revenue.diff > 0 || monthData.revenue.diff < 0) {
                            const formatted = window.infinito.vao.controller.moneyHelper.formatMoneyBracketStyle(
                                monthData.revenue.diff,
                                Constants.REVENUE_DIGITS,
                                true,
                                this.hotel.locale
                            );
                            const _varBlock = new NumericVarianceBlock({
                                numericValue: monthData.revenue.diff,
                                formattedValue: formatted,
                                beEmptyOnEmpty: 'true'
                            });
                            varBlock = html`
                                <div style="font-size:.7rem;">${_varBlock}</div>`;
                        } else {
                            varBlock = html``;
                        }
                        cell.value = html`
                            <div style="flex-direction:column;">
                                <div>${varBlock}</div>
                            </div>`;
                    } else {
                        cell.value = null;
                    }
                    cell.isLoading = false;
                });

                if (!foundAnyData) {
                    super.empty();
                }
            }
        );
    }

    fill() {
        if (
            !this.hotel
            || typeof this.hotel !== 'object'
            || !('id' in this.hotel)
            || !window.infinito.vao.controller.dateHelper.isDateStr(this.recordDate)
            || !$.isNumeric(this.pickupSetting)
        ) {
            super.empty();
            return;
        }

        let rows = super.makeTableRows();
        this.fillRows();
        let table = super.reflowTable(rows);
        super.domTheTable(table);
    }

    formatPercentageValue(unformattedValue) {
        let percent = parseFloat(unformattedValue);
        if (!Number.isNaN(percent)) {
            return percent.toFixed(2) + '%';
        }
        return unformattedValue;
    }
}

window.vao = window.vao || {};
window.vao.components = window.vao.components || {};
window.vao.components.PickupPerMonthHotel = PickupPerMonthHotel;
customElements.define('vao-pickup-per-month-hotel', PickupPerMonthHotel);
